"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeRadioSmall = exports.sizeRadioMedium = exports.sizeRadioLarge = exports.sizeIconTinyWidth = exports.sizeIconTinyStrokeWidth = exports.sizeIconTinyMargin = exports.sizeIconTinyHeight = exports.sizeIconSmallWidth = exports.sizeIconSmallStrokeWidth = exports.sizeIconSmallMargin = exports.sizeIconSmallHeight = exports.sizeIconMediumWidth = exports.sizeIconMediumStrokeWidth = exports.sizeIconMediumMargin = exports.sizeIconMediumHeight = exports.sizeIconLargeWidth = exports.sizeIconLargeStrokeWidth = exports.sizeIconLargeMargin = exports.sizeIconLargeHeight = exports.sizeIconHugeWidth = exports.sizeIconHugeStrokeWidth = exports.sizeIconHugeMargin = exports.sizeIconHugeHeight = exports.sizeIconDefaultWidth = exports.sizeIconDefaultStrokeWidth = exports.sizeIconDefaultMargin = exports.sizeIconDefaultHeight = exports.sizeCheckboxSmall = exports.sizeCheckboxMedium = exports.sizeCheckboxLarge = exports.size900 = exports.size850 = exports.size800 = exports.size750 = exports.size75 = exports.size700 = exports.size600 = exports.size525 = exports.size500 = exports.size50 = exports.size400 = exports.size375 = exports.size350 = exports.size300 = exports.size250 = exports.size25 = exports.size200 = exports.size150 = exports.size100 = void 0;
const size25 = exports.size25 = "5px";
const size50 = exports.size50 = "10px";
const size75 = exports.size75 = "15px";
const size100 = exports.size100 = "20px";
const size150 = exports.size150 = "20px";
const size200 = exports.size200 = "25px";
const size250 = exports.size250 = "30px";
const size300 = exports.size300 = "35px";
const size350 = exports.size350 = "40px";
const size375 = exports.size375 = "45px";
const size400 = exports.size400 = "50px";
const size500 = exports.size500 = "60px";
const size525 = exports.size525 = "80px";
const size600 = exports.size600 = "125px";
const size700 = exports.size700 = "250px";
const size750 = exports.size750 = "375px";
const size800 = exports.size800 = "500px";
const size850 = exports.size850 = "750px";
const size900 = exports.size900 = "1000px";
const sizeCheckboxSmall = exports.sizeCheckboxSmall = "14px";
const sizeCheckboxMedium = exports.sizeCheckboxMedium = "18px";
const sizeCheckboxLarge = exports.sizeCheckboxLarge = "22px";
const sizeRadioSmall = exports.sizeRadioSmall = "12px";
const sizeRadioMedium = exports.sizeRadioMedium = "16px";
const sizeRadioLarge = exports.sizeRadioLarge = "20px";
const sizeIconTinyWidth = exports.sizeIconTinyWidth = "15px";
const sizeIconTinyHeight = exports.sizeIconTinyHeight = "15px";
const sizeIconTinyMargin = exports.sizeIconTinyMargin = "0px";
const sizeIconTinyStrokeWidth = exports.sizeIconTinyStrokeWidth = "2px";
const sizeIconSmallWidth = exports.sizeIconSmallWidth = "20px";
const sizeIconSmallHeight = exports.sizeIconSmallHeight = "20px";
const sizeIconSmallMargin = exports.sizeIconSmallMargin = "2px";
const sizeIconSmallStrokeWidth = exports.sizeIconSmallStrokeWidth = "1.5px";
const sizeIconMediumWidth = exports.sizeIconMediumWidth = "25px";
const sizeIconMediumHeight = exports.sizeIconMediumHeight = "25px";
const sizeIconMediumMargin = exports.sizeIconMediumMargin = "5px";
const sizeIconMediumStrokeWidth = exports.sizeIconMediumStrokeWidth = "1.5px";
const sizeIconDefaultWidth = exports.sizeIconDefaultWidth = "25px";
const sizeIconDefaultHeight = exports.sizeIconDefaultHeight = "25px";
const sizeIconDefaultMargin = exports.sizeIconDefaultMargin = "5px";
const sizeIconDefaultStrokeWidth = exports.sizeIconDefaultStrokeWidth = "1.5px";
const sizeIconLargeWidth = exports.sizeIconLargeWidth = "35px";
const sizeIconLargeHeight = exports.sizeIconLargeHeight = "35px";
const sizeIconLargeMargin = exports.sizeIconLargeMargin = "10px";
const sizeIconLargeStrokeWidth = exports.sizeIconLargeStrokeWidth = "1.35px";
const sizeIconHugeWidth = exports.sizeIconHugeWidth = "50px";
const sizeIconHugeHeight = exports.sizeIconHugeHeight = "50px";
const sizeIconHugeMargin = exports.sizeIconHugeMargin = "15px";
const sizeIconHugeStrokeWidth = exports.sizeIconHugeStrokeWidth = "1.25px";